import { useEffect, useRef, useState } from "react";

const GoogleTranslate = () => {
    // eslint-disable-next-line
  const [lang, setLang] = useState("Select Language");
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    // Add Google Translate script only once
    if (!document.getElementById("google-translate-script")) {
      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    }

    // Global function required by Google
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "af,ar,bn,zh-CN,zh-TW,en,fil,fr,hi,id,mn,pt,sl,es,vi",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        "google_translate_element"
      );

      // Update button text dynamically
      const interval = setInterval(() => {
        const frame = document.querySelector("iframe.goog-te-menu-frame");
        if (frame) {
          frame.contentWindow.document
            .querySelectorAll("a")
            .forEach((el) => {
              el.addEventListener("click", () => {
                setLang(el.textContent);
              });
            });
          clearInterval(interval);
        }
      }, 500);
    };
  }, []);

  return (
    <div id="google_translate_element"></div>
  );
};

export default GoogleTranslate;
